import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/app/config/environments/environment';

@Injectable()
export class GateChangesSocket extends Socket {
  constructor(cookieService: CookieService) {
    super({
      url: `${environment.socketIoConfig.url}/gates`,
      options: {
        ...environment.socketIoConfig.options,
        ...{
          query: {
            tenant: cookieService.get('x-tenant-id'),
          },
        },
      },
    });
  }
}
